import React, { useEffect, useState, useRef } from "react";
import { getAllAllowance, updateAllowance, addAllowance, deleteAllowance } from "../../api/allowanceApi";

import "../../css/CustomTable.css";
import { hasRight } from "../../utils/userRights";

export default function Allowance() {
  const [allowances, setAllowances] = useState([]);
  const [formData, setFormData] = useState({
    allowanceName: "",
    description: "",
    percentage: 0,
    amount: 0,
    includeInForm16: false,   
    form16Section: null,
    includeInGross: "Y",  
    allowanceType: "Regular" 
  });
  const [editId, setEditId] = useState(null);

  const formRef = useRef(null); //reference for form

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const allowanceData = await getAllAllowance();
      setAllowances(allowanceData.data || allowanceData);

      // console.log("allowances:", allowances);
      console.log("allowanceData:", allowanceData);

    } catch (error) {
      console.error("Error fetching allowances", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payload = {
      ...formData,
      includeInForm16: formData.includeInForm16 || false,
      form16Section: formData.includeInForm16 ? formData.form16Section : null,
    };

    try {
      if (editId) {
        await updateAllowance(editId, payload);
      } else {
        await addAllowance(payload);
        alert("Allowance created successfully 🎉");
      }
      setFormData({
        allowanceName: "",
        description: "",
        percentage: 0,
        amount: 0,
        includeInForm16: false,
        form16Section: "",
        includeInGross: "Y",  
        allowanceType: ""
      });
      setEditId(null);
      fetchData();
    } catch (error) {
      console.error("Error saving allowance", error);
      alert("Something went wrong while saving ");
    }
 };

  const handleEdit = (item) => {
    setFormData({
      allowanceID: item.allowanceID,
      allowanceName: item.allowanceName,
      description: item.description,
      percentage: item.percentage,
      amount: item.amount,
      includeInForm16: item.includeInForm16,
      form16Section: item.form16Section,
      includeInGross: item.includeInGross,  
      allowanceType: item.allowanceType
    });
    setEditId(item.allowanceID);

    // scroll form into view when editing
    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this allowance?")) {
      try {
        await deleteAllowance(id);
        alert("Allowance deleted successfully 🗑️");
        fetchData();
      } catch (error) {
        console.error("Error deleting allowance", error);
        alert("Failed to delete allowance");
      }
    }
 };

  const handleClear = () => {
    setFormData({ allowanceName: "", description: "", percentage: 0, amount: 0, includeInForm16: false, form16Section: "", includeInGross: "",  allowanceType: ""});
    setEditId(null);
  };

  return (
  <div className="container-fluid p-1">
    {/* Heading */}
    <h4 className="allowance-heading">Allowance Details</h4>

    {/* Add / Edit Form */}

    <form
      ref={formRef}
      className="d-flex flex-wrap align-items-end gap-2 mb-3"
      onSubmit={handleSubmit}
    >
      <div className="flex-grow-1">
        <label className="form-label">Allowance Name *</label>
        <input
          type="text"
          className="form-control"
          value={formData.allowanceName}
          onChange={(e) =>
            setFormData({ ...formData, allowanceName: e.target.value })
          }
          required
        />
      </div>
        
      <div className="flex-grow-1">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
        />
      </div>
        
      <div style={{ width: "100px" }}>
        <label className="form-label">Percentage *</label>
        <input
          type="number"
          className="form-control"
          value={formData.percentage}
          onChange={(e) =>
            setFormData({ ...formData, percentage: e.target.value })
          }
          min="0"
          required
        />
      </div>
        
      <div style={{ width: "100px" }}>
        <label className="form-label">Amount</label>
        <input
          type="number"
          className="form-control"
          value={formData.amount}
          onChange={(e) =>
            setFormData({ ...formData, amount: e.target.value })
          }
        />
      </div>
        
      <div className="d-flex flex-column" style={{ width: "130px" }}>
        <label className="form-label">Include in Form16</label>
        <input
          type="checkbox"
          checked={formData.includeInForm16}
          onChange={(e) => {
            const checked = e.target.checked;
            setFormData({
              ...formData,
              includeInForm16: checked,
              form16Section: checked ? formData.form16Section : null, // reset section if unchecked
            });
          }}
        />
      </div>
      {formData.includeInForm16 && (
        <div style={{ width: "150px" }}>
          <label className="form-label">Form16 Section</label>
          <input
            type="text"
            className="form-control"
            value={formData.form16Section || ""}
            onChange={(e) =>
              setFormData({ ...formData, form16Section: e.target.value })
            }
            required={formData.includeInForm16} // make required only if checkbox is checked
          />
        </div>
      )}

      {/* Include In Gross dropdown */}
      <div style={{ width: "140px" }}>
        <label className="form-label">Include in Gross</label>
        <select
          className="form-select"
          value={formData.includeInGross}
          onChange={(e) =>
            setFormData({ ...formData, includeInGross: e.target.value })
          }
        >
          <option value="Y">Yes</option>
          <option value="N">No</option>
        </select>
      </div>
        
      {/* Allowance Type dropdown */}
      <div style={{ width: "160px" }}>
        <label className="form-label">Allowance Type</label>
        <select
          className="form-select"
          value={formData.allowanceType}
          onChange={(e) =>
            setFormData({ ...formData, allowanceType: e.target.value })
          }
        >
          <option value="Regular">Regular</option>
          <option value="Bonus">Bonus</option>
          <option value="Incentive">Incentive</option>
          <option value="other1">Other1</option>
          <option value="other2">Other2</option>
        </select>
      </div>

      

        
      <div className="d-flex gap-2">
        <button type="submit" className="btn btn-success">
          {editId ? "Update" : "Add"}
        </button>
        <button type="button" className="btn btn-secondary" onClick={handleClear}>
          Clear
        </button>
      </div>
    </form>


    {/* Table */}
    <div className="allowance-table-container">
      <table className="allowance-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Allowance Name</th>
            {/* <th>Description</th> */}
            <th>Percentage</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {allowances.length > 0 ? (
            allowances.map((item, index) => (
              <tr key={item.allowanceID || index}>
                <td>{index + 1}</td>
                <td>{item.allowanceName}</td>
                {/* <td>{item.description}</td> */}
                <td>{item.percentage}</td>
                <td>{item.amount}</td>
                <td>
                  {/* Edit button → only show if user has Update right */}
                  {/* Delete button → only show if user has Delete right */}
                  {hasRight("AllowanceMaster", "update") && (
                    <button className="edit" onClick={() => handleEdit(item)}>
                      Edit
                    </button>
                  )}
                
                  {hasRight("AllowanceMaster", "delete") && (
                    <button
                      className="delete"
                      onClick={() => handleDelete(item.allowanceID)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No Allowances found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

}

